(function () {
  if (window.__lamelGiftInit) return;
  window.__lamelGiftInit = true;

  // The bar is rendered with the current cart in Liquid (snippets/free-gift-bar.liquid),
  // so this script only keeps it in sync after cart changes — no request on page load.
  var CART_RE = /\/cart\/(add|change|update|clear)/;

  // same look as Liquid's money_without_trailing_zeros: $30 / $12.40
  function money(cents, currency) {
    var digits = cents % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(digits);
    }
  }

  function render(box, total) {
    var limit = parseInt(box.dataset.threshold, 10);
    if (!limit) return;

    var bar = box.querySelector('.lamel-gift__bar');
    var fill = box.querySelector('.lamel-gift__fill');
    var note = box.querySelector('.lamel-gift__note');
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var pct = Math.min(100, Math.floor((total * 100) / limit));

    box.dataset.total = total;
    if (fill) fill.style.width = pct + '%';
    if (bar) bar.setAttribute('aria-valuenow', pct);

    if (total >= limit) {
      box.dataset.state = 'done';
      if (note) note.textContent = 'Unlocked';
    } else {
      box.dataset.state = 'idle';
      if (note) note.textContent = money(limit - total, currency) + ' left';
    }
  }

  function refresh() {
    var boxes = document.querySelectorAll('[data-lamel-gift]');
    if (!boxes.length) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        boxes.forEach(function (box) { render(box, cart.items_subtotal_price); });
      })
      .catch(function () {});
  }

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var arg = arguments[0];
    var url = arg && arg.url ? arg.url : String(arg);
    var request = nativeFetch.apply(this, arguments);
    if (CART_RE.test(url)) {
      request.then(function () { setTimeout(refresh, 300); }).catch(function () {});
    }
    return request;
  };

  // page restored from the back/forward cache: the cart may have changed meanwhile
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });
})();